import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Injectable, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ProductDto } from 'src/app/model/ProductDto';
import { ImprovementAnalisys, ProjectImprovementReleases } from 'src/app/model/ProjectImprovementReleases';
import { ProductImprovementDetailsComponent } from '../product-improvement-details/product-improvement-details.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportsService } from 'src/app/core/services/reports.service';

@Component({
  selector: 'ms-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  animations: [
    trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
@Injectable({providedIn: 'root'})
export class ReleaseNotesComponent implements OnInit {
  constructor(
    private productDownloadService: ProductDownloadService,
    private navigateService: NavigateService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private reportsService: ReportsService
  ) { }

  @Input() productDto: ProductDto = null;
  @Input() title: string = '';
  @Input() date: string = '';
  @Input() isLoading: boolean = false;
  @Input() functionalAreasTable: MatTableDataSource<string> = new MatTableDataSource<string>();
  @Input() functionalAreasImprovementsTables: Map<string, MatTableDataSource<ProjectImprovementReleases>> = new Map<string, MatTableDataSource<ProjectImprovementReleases>>();;
  @Input() expandedElement: string | null;
  @Input() localizedFields: Map<string, string> = new Map<string, string>();

  displayedColumns: string[] = ['area','expand'];
  displayedImprovementColumns: string[] = ['nr','description','country'];

  async ngOnInit(): Promise<void> {
  }


  getCountriesString(countries: string): string{
    return countries ? `${countries}` : ''
  }

  async getPdf(){
    if(this.productDto.ProductCode)
      await this.productDownloadService.createImprovementPDF(`${this.productDto.ProductCode} rel${this.productDto.ReleaseNr ?? ' all'}`, this.date, this.getAllImprovements(), this.functionalAreasTable.data);
    else
      await this.productDownloadService.createImprovementPDF(`Custom search`, new Date(Date.now()).toLocaleDateString(), this.getAllImprovements(), this.functionalAreasTable.data);
  }

  getAllImprovements(): ProjectImprovementReleases[]{
    let improvements: ProjectImprovementReleases[] = []
    this.functionalAreasImprovementsTables.forEach((item) => { improvements = improvements.concat(item.data)})
    return improvements;
  }

  public async openImprovement(improvement: ProjectImprovementReleases) {
    try {
      improvement.Requirements = this.reportsService.setObjectsEmptyFields<ImprovementAnalisys>(improvement.Requirements)

      if(improvement.ProjImprFatherID){
        let fatherRes = await this.productDownloadService.getProductImprovements("","",improvement.ProjImprFatherID)
        if(!fatherRes.Result || !fatherRes.Content || fatherRes.Content.length > 1) throw new Error();
        this.navigateService.setLocalStorageData('improvementFather', JSON.stringify(fatherRes.Content[0]))
      }

      let archiviedDocuments = await this.productDownloadService.getProjectArchiviedDocument(improvement.ProjImprID, "project")
      if(!archiviedDocuments.Result) throw new Error();
      this.navigateService.setLocalStorageData('archiviedDocuments', JSON.stringify(archiviedDocuments.Content))
    }
    catch (err){
      improvement.ProjImprFatherID = 0;
    }
    finally {
      this.navigateService.setLocalStorageData('improvement', JSON.stringify(improvement))
      this.navigateService.setLocalStorageData('productDto', JSON.stringify(this.productDto))
      let dialogRef = this.dialog.open(ProductImprovementDetailsComponent);
      const sub = dialogRef.componentInstance.openFather.subscribe(() => { this.openFather(improvement); });
      dialogRef.afterClosed().subscribe(() => { sub.unsubscribe() });
    }
  }

  public async openFather(improvement: ProjectImprovementReleases) {
    if(this.navigateService.getLocalStorageData<ProjectImprovementReleases>('improvementFather'))
      this.openImprovement(this.navigateService.getLocalStorageData<ProjectImprovementReleases>('improvementFather'))
    else
      this.snackBar.open("Father project not found", "", { duration: 600 });
  }

  public setParameters(row: string) {
    this.expandedElement = this.expandedElement === row ? null : row;
  }
}
